import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import TestimonialCard from '../components/TestimonialCard';
import { obtenerTestimonios } from '../firebase/firestore';

const SERVICIOS_PREVIEW = [
  { icono: '🧠', titulo: 'Trauma y PTSD', descripcion: 'Abordaje especializado para superar experiencias traumáticas usando terapias basadas en evidencia.' },
  { icono: '💆', titulo: 'Ansiedad y Estrés', descripcion: 'Herramientas concretas para regular el sistema nervioso y recuperar la calma en la vida cotidiana.' },
  { icono: '🌱', titulo: 'Duelo y Pérdidas', descripcion: 'Acompañamiento compasivo en procesos de duelo por pérdidas de todo tipo.' },
];

const TESTIMONIOS_MOCK = [
  { texto: 'Después de años cargando solo, encontrar un espacio así cambió todo. Me siento por primera vez en control de mi vida.', nombre: 'M.L.', servicio: 'Trauma y PTSD' },
  { texto: 'La profesionalidad y calidez del equipo es incomparable. Recomiendo Serenidad a cualquiera que lo esté considerando.', nombre: 'R.G.', servicio: 'Ansiedad' },
  { texto: 'Me ayudaron a transitar el duelo con mucha gentileza. No estaba solo en el proceso.', nombre: 'F.T.', servicio: 'Duelo' },
];

export default function Home() {
  const [testimonios, setTestimonios] = useState(TESTIMONIOS_MOCK);

  useEffect(() => {
    obtenerTestimonios()
      .then(data => { if (data.length > 0) setTestimonios(data); })
      .catch(() => {});
  }, []);

  return (
    <>
      <Hero />

      {/* Servicios preview */}
      <section className="py-24 bg-stone-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="mb-14">
            <p className="text-teal-600 text-xs uppercase tracking-widest mb-3">Lo que ofrecemos</p>
            <h2 className="section-title">Nuestros servicios</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {SERVICIOS_PREVIEW.map(s => <ServiceCard key={s.titulo} {...s} />)}
          </div>
          <Link to="/servicios" className="btn-outline">Ver todos los servicios</Link>
        </div>
      </section>

      {/* Testimonios */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="mb-14">
            <p className="text-teal-600 text-xs uppercase tracking-widest mb-3">Experiencias reales</p>
            <h2 className="section-title">Lo que dicen nuestros pacientes</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {testimonios.map((t, i) => <TestimonialCard key={i} {...t} />)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-teal-900 text-white text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="font-display text-4xl md:text-5xl mb-6">El primer paso es el más importante</h2>
          <p className="text-teal-200 text-base leading-relaxed mb-10">
            Agenda una consulta inicial sin compromiso. Nuestro equipo te acompañará desde el primer momento.
          </p>
          <Link to="/contacto" className="btn-primary bg-white text-teal-900 hover:bg-teal-50">
            Agendar cita gratuita
          </Link>
        </div>
      </section>
    </>
  );
}